import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = {
  class: "brand",
  href: "/",
  "aria-label": "LabOS home"
}
const _hoisted_3 = ["src"]

import logoSrc from '@/assets/picture/LabOS_logo.png'

const loginUrl = 'https://app.ai4labos.com/login'

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderNav',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!

  return (_openBlock(), _createBlock(_component_a_layout_header, { class: "labos-header" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(logoSrc),
            alt: "LabOS logo",
            class: "logo-img"
          }, null, 8, _hoisted_3),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "brand-text" }, "LabOS", -1))
        ]),
        _createElementVNode("nav", {
          class: "nav-menu",
          "aria-label": "Account"
        }, [
          _createElementVNode("a", {
            class: "auth-btn login-btn",
            href: loginUrl
          }, "Login"),
          _createElementVNode("a", {
            class: "auth-btn signup-btn",
            href: loginUrl
          }, "Sign up")
        ])
      ])
    ]),
    _: 1
  }))
}
}

})